/**
 * Fechas solo-calendario (sin hora) desde la API — evita desfase UTC en Colombia.
 */

/** YYYY-MM-DD del día local (para input type="date") */
export function toInputDateFromLocalDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function getTodayInputDate() {
    return toInputDateFromLocalDate(new Date());
}

/** YYYY-MM-DD para input type="date" */
export function toInputDateValue(value) {
    if (value == null || value === '') return '';
    const datePart = String(value).trim().split(/[T\s]/)[0];
    return /^\d{4}-\d{2}-\d{2}$/.test(datePart) ? datePart : '';
}

/** Muestra dd/mm/yyyy sin cambiar el día por zona horaria */
export function formatDateOnly(value, locale = 'es-CO') {
    const datePart = toInputDateValue(value);
    if (!datePart) return '';
    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return datePart;
    return new Date(y, m - 1, d).toLocaleDateString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

/** Días hasta la fecha (0 = hoy, negativo = vencido) */
export function daysUntilDateOnly(value) {
    const datePart = toInputDateValue(value);
    if (!datePart) return null;
    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;
    const target = new Date(y, m - 1, d);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    return Math.round((target - today) / (1000 * 60 * 60 * 24));
}
